import { Placement } from '../Menu/menu.type';

export const formatDateAccordingToDateType = (date: Date, type?: string) => {
  const day = date?.getDate() < 10 ? `0${date?.getDate()}` : date?.getDate();
  const month = date?.getMonth() < 9 ? `0${date?.getMonth() + 1}` : date?.getMonth() + 1;
  const year = date?.getFullYear();

  switch (type) {
    case 'dd/mm/yyyy':
      return `${day}/${month}/${year}`;
    case 'mm/dd/yyyy':
      return `${month}/${day}/${year}`;
    case 'yyyy/mm/dd':
      return `${year}/${month}/${day}`;
    case 'yyyy/dd/mm':
      return `${year}/${day}/${month}`;
    case 'yyyy-mm-dd':
      return `${year}-${month}-${day}`;
    case 'yyyy-dd-mm':
      return `${year}-${day}-${month}`;
    case 'dd-mm-yyyy':
      return `${day}-${month}-${year}`;
    case 'mm-dd-yyyy':
      return `${month}-${day}-${year}`;
    default:
      return `${day}/${month}/${year}`;
  }
};

export const isValidDate = (date: string, type?: string) => {
  const dateArr = date.split('/');
  const day = dateArr[0];
  const month = dateArr[1];
  const year = dateArr[2];

  // if (type === 'mm/dd/yyyy') {
  //   return new Date(`${month}/${day}/${year}`).toString() !== 'Invalid Date';
  // }

  if (new Date(`${month}/${day}/${year}`).toString() !== 'Invalid Date') {
    return `${month}/${day}/${year}`;
  }
};

/**
 *
 * @param triggerHeight
 * @param triggerWidth
 * @param contentHeight
 * @param contentWidth
 * @param placement
 * @param x
 * @param y
 * @returns left and top coordinates for the content
 */
export const getAbsoluteCoordinates = (
  triggerHeight: number,
  triggerWidth: number,
  contentHeight: number,
  contentWidth: number,
  placement: Placement,
  x: number,
  y: number,
) => {
  const { innerHeight, innerWidth } = window;

  let top = 0;
  let left = 0;

  switch (placement) {
    case 'top':
      top = -contentHeight;
      left = (triggerWidth - contentWidth) / 2;

      //* ideally this should not happen
      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'topLeft':
      top = -contentHeight;
      left = triggerWidth - contentWidth;

      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'topRight':
      top = -contentHeight;
      left = 0;

      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'bottom':
      top = triggerHeight;
      left = (triggerWidth - contentWidth) / 2;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'bottomLeft':
      top = triggerHeight;
      left = triggerWidth - contentWidth;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      //* this is not gonna happen
      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'bottomRight':
      top = triggerHeight;
      left = 0;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      //* this is not gonna happen
      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    default:
      top = triggerHeight;
      left = 0;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top: triggerHeight,
        left: 0,
      };
  }
};
